import { useCallback } from 'react';
import { onSearchResultContext, onSearchResultHighlighted, onSearchResultSelected, useAnalytics } from '../../common/analytics';
/**
 * Returns callbacks which fire analytic events which should be triggered on
 * various user actions on a search result.
 */
export var useSearchResultAnalyticsCallbacks = function useSearchResultAnalyticsCallbacks(_ref) {
  var onHighlighted = _ref.onHighlighted,
    onSelect = _ref.onSelect,
    screen = _ref.screen,
    actionSubject = _ref.actionSubject;
  var _useAnalytics = useAnalytics(),
    fireAnalyticsEvent = _useAnalytics.fireAnalyticsEvent;
  var onHighlightCallback = useCallback(function () {
    fireAnalyticsEvent(onSearchResultHighlighted({
      screen: screen,
      actionSubject: actionSubject
    }));
    onHighlighted === null || onHighlighted === void 0 || onHighlighted();
  }, [actionSubject, fireAnalyticsEvent, onHighlighted, screen]);
  var onSelectCallback = useCallback(function (e) {
    fireAnalyticsEvent(onSearchResultSelected({
      screen: screen,
      actionSubject: actionSubject
    }));
    onSelect === null || onSelect === void 0 || onSelect(e);
  }, [actionSubject, fireAnalyticsEvent, onSelect, screen]);
  var onContextMenuCallback = useCallback(function (e) {
    fireAnalyticsEvent(onSearchResultContext({
      screen: screen,
      actionSubject: actionSubject
    }));
  }, [actionSubject, fireAnalyticsEvent, screen]);
  return {
    onHighlightCallback: onHighlightCallback,
    onSelectCallback: onSelectCallback,
    onContextMenuCallback: onContextMenuCallback
  };
};